export default "<svg viewBox=\"0 0 7.95 12.44\"><path d=\"M.75,8.41l3.23,3,3.22-3\"/><path d=\"M7.2,4,4,1,.75,4\"/></svg>";